import { BodySecondary } from '@liveauctioneers/hammer-ui-core/text';
import { CatalogNearMe } from '@/redux/modules/auctionsNearMe/catalogsNearMe.types';
import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import { useMemo } from 'react';

type Props = {
    catalogsNearMe: CatalogNearMe[];
};

export const AuctionsNearMeAuctionHouseCount = ({ catalogsNearMe }: Props) => {
    const numberOfAuctionHouses = useMemo(() => {
        return catalogsNearMe.filter(
            (catalog: CatalogNearMe, currentIndex: number) =>
                catalogsNearMe.findIndex(
                    (comparedCatalog: CatalogNearMe) => comparedCatalog.houseDetails.id === catalog.houseDetails.id
                ) === currentIndex
        ).length;
    }, [catalogsNearMe]);

    return (
        <BodySecondary className="hui-text-h3">
            {numberOfAuctionHouses === 1 ? (
                <FormattedMessage id="nearby_auction_houses_count_single" />
            ) : (
                <FormattedMessage
                    id="nearby_auction_houses_count"
                    values={{ numberOfHouses: numberOfAuctionHouses }}
                />
            )}
        </BodySecondary>
    );
};
